import { ProactivePrescriptionRuleProvider } from '@common/stores'
import { UserProactivePrescriptionDetails } from '@hospital/views/shared/userprofile/UserProactivePrescriptionDetails'
import { observer } from 'mobx-react';
import React from 'react'

export const UserProactivePrescriptionDetailsContainer = observer(() => {
  return (
    <ProactivePrescriptionRuleProvider>
      <UserProactivePrescriptionDetails />
    </ProactivePrescriptionRuleProvider>
  )
});
